var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-size":"16pt"}},[_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }